import SessionAccessStatusExpired from './SessionAccessStatusExpired';

export default SessionAccessStatusExpired;
